import { createSlice } from "@reduxjs/toolkit";
import addEditPac from "@custom/rtk-apis/Setting/addEditPAC";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const addEditPACSlice = createSlice({
  name: "addEditPACSlice",
  initialState,
  reducers: {
    closePACModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(addEditPac.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEditPac.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditPac.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addEditPACSlice.reducer;
export const { closePACModal } = addEditPACSlice.actions;
